import React from 'react';
import { Col, Row } from 'react-bootstrap';
import DisplayItTable from './display-it-table';

const DisplayItPerformance = ({
  index, name, display_objectives: displayObjectives, customer_number: customerNumber
}) =>
  (
    <div className="container-fluid" key={index}>
      <Row>
        <Col md={12}>
          <h3 className='store-name'>
            {name}, {customerNumber}
          </h3>
        </Col>
      </Row>
      <Row>
        {
            displayObjectives.map((value, key) => (
              <DisplayItTable key={key} {...value} />
            ))
          }
      </Row>
    </div>
  );

export default DisplayItPerformance;



// WEBPACK FOOTER //
// ./src/components/store-performance/display-it/display-it-performance.jsx